import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Banner.css';
import Typical from 'react-typical';
import Resume from '../../resume/resume.pdf';
import Particles from "react-tsparticles";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faDev, faFacebook, faGithub, faLinkedinIn, faTwitter } from '@fortawesome/free-brands-svg-icons';
const Banner = () => {
    const particlesInit = (main) => {
        console.log(main);

        // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
    };

    const particlesLoaded = (container) => {
        console.log(container);
    };

    // Icons
    const elementGithub = <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>
    const elementFacebook = <FontAwesomeIcon icon={faFacebook}></FontAwesomeIcon>
    const elementLinkedinIn = <FontAwesomeIcon icon={faLinkedinIn}></FontAwesomeIcon>
    const elementTwitter = <FontAwesomeIcon icon={faTwitter}></FontAwesomeIcon>
    const elementDev = <FontAwesomeIcon icon={faDev}></FontAwesomeIcon>

    return (
        <Container id="banner" className="banner-body my-5 py-5">

            <Row className="banner-text">
                <Col md={7}>
                    <Particles
                        id="tsparticles"
                        init={particlesInit}
                        loaded={particlesLoaded}
                        options={{
                            fpsLimit: 100,
                            interactivity: {
                                events: {
                                    onClick: {
                                        enable: true,
                                        mode: "push",
                                    },
                                    onHover: {
                                        enable: true,
                                        mode: "repulse",
                                    },
                                    resize: true,
                                },
                                modes: {
                                    bubble: {
                                        distance: 400,
                                        duration: 2,
                                        opacity: 0.8,
                                        size: 40,
                                    },
                                    push: {
                                        quantity: 5,
                                    },
                                    repulse: {
                                        distance: 120,
                                        duration: 0.4,
                                    },
                                },
                            },
                            particles: {

                                color: {
                                    value: "#B2BEB5",
                                },
                                links: {
                                    color: "#B2BEB5",
                                    distance: 150,
                                    enable: true,
                                    opacity: 0.2,
                                    width: 0.5,
                                },
                                collisions: {
                                    enable: true,
                                },
                                move: {
                                    direction: "none",
                                    enable: true,
                                    outMode: "bounce",
                                    random: true,
                                    speed: 2,
                                    straight: true,
                                },
                                number: {
                                    density: {
                                        enable: true,
                                        value_area: 2000,
                                    },
                                    value: 100,
                                },
                                opacity: {
                                    value: 0.1,
                                },
                                shape: {
                                    type: "circle",
                                },
                                size: {
                                    random: true,
                                    value: 6,
                                },
                            },
                            detectRetina: true,
                        }}
                    />
                    <p className="name">Hi, my name is</p>
                    <h1 style={{ fontWeight: "bold" }}>Aulad Hossen. <br />
                        <span style={{ color: "#8892B0", fontWeight: "bold" }}>
                            <Typical
                                loop={Infinity}
                                wrapper="b"
                                steps={[
                                    'Frontend Web Developer',
                                    1500,
                                    'React.js Developer',
                                    1500,
                                    'JavaScript Developer',
                                    1500,
                                    'MERN Stack Developer',
                                    1500,
                                    'Software Developer',
                                    1500,
                                ]} /></span></h1>
                    <p className="my-5" style={{ color: "#8892B0" }}>I’m an innovative and energetic Frontend Web Developer with knowledge of building and maintaining responsive websites. Proficient in HTML5, CSS3, Bootstrap, JavaScript(ES6), React.js, plus modern libraries, and frameworks.</p>
                    <a className="custom-button" target="_blank" style={{ marginTop: "0px", textDecoration: "none" }} href={Resume} download="CV of Aulad Hossen">Download Resume</a>
                </Col>
                <Col md={4} className="ms-5">
                    <img className="about-image w-75 mt-3" src="https://i.ibb.co/Xk5P5Pd/199736763-3659991844224937-7400949476269238406-n-removebg-preview-4.png" alt="" />
                </Col>
            </Row>
            <Row>
                <Col className="icons">
                    <ul>
                        <a href="https://github.com/auladhimel" target="_blank"><li> {elementGithub}</li></a>
                        <a href="https://www.facebook.com/auladhimel112/" target="_blank"><li> {elementFacebook}</li></a>
                        <a href="https://www.linkedin.com/in/aulad-hossen-himel-665930183/" target="_blank"><li> {elementLinkedinIn}</li></a>
                        <a href="https://twitter.com/HimelAulad" target="_blank"><li> {elementTwitter}</li></a>
                        <a href="https://dev.to/auladhossen"><li> {elementDev}</li></a>
                    </ul>

                </Col>
                <Col className="vl">
                </Col>
            </Row>
        </Container >
    );
};

export default Banner;